import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import '../../App.css'
import * as actionsCreators from '../../store/actions/index'
import axios from '../../http-config';
import _ from 'lodash'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import RcConfiguration from './RcConfiguration'

function RCEdit (props) {
    const [singleUlb, setUlb] = useState({});

    useEffect(() => {
        const payload = {
                        token : props.token,
                        id    : props.match.params.id
        }
        const url = `/ulb/configuration/${payload.id}`
        axios({
                        method   : 'get',
                        url      : url,
                        headers  : {'Authorization': `Bearer ${payload.token}`}
                   })
                   .then((response) => {
                       setUlb(response.data.data.loads[0])
                   })
                   .catch((err) => {
                       
                   })
      },[]);
    
    const handleSubmit = (payload, data)=>{
        props.onEditconfigurationData(payload, data, props)
    }

        return(
            
            <div className="create_ulb">
            <div className="dashboard_top_path">
           
                <p><img src="images/left-arrow.svg" />ULB Configuration / <span>Edit ULB Configuration</span></p>
            </div>
            <div className="dashboard_right_content">
                <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                <div className="dashboard_right_content_top">
                <h5><Link to = {`/`} className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>Edit ULB Configuration</h5>
                </div>
                <div className="create_ulb_content_outer">
                    <div className="create_ulb_content">
                { 
                 !_.isEmpty(singleUlb)&&(
                     <RcConfiguration {...singleUlb} id={props.match.params.id} disabled={true} handleSubmit={handleSubmit}/>
                 )
                }      
                    </div>
                </div>
            </div>
        </div>
                
        )
}



const mapStateToProps = (state,props) => {
    
return {
    token:state.auth.token
}
}

const mapDispatchToProps = dispatch => {
return {
    onEditconfigurationData: (payload, data, props) => dispatch(actionsCreators.configuration(payload, data, props))
}
}

export default  connect(mapStateToProps, mapDispatchToProps)(RCEdit);

